import { useDispatch, useSelector } from 'react-redux'
import { activeTableSheetKeyFieldSelector, activeSheetSelector } from 'apps/formsCreationKit/store/selectors/entities'
import { alphaEntryTypesSelector } from 'apps/formsCreationKit/store/selectors/types'
import { CancelConfirmDialog } from 'apps/studio/components/dialogs/CancelConfirmDialog'
import { upgradeTableToPrefilled } from 'apps/formsCreationKit/store/actions/sharedActions'
import { lib } from '@gocanvas/client'
const { defaultValue } = lib.Dropdown


export const ConvertToPrefilledTable = ({
  onClose = () => {},
}) => {
  const dispatch = useDispatch()
  const keyField = useSelector(activeTableSheetKeyFieldSelector)
  const entryTypes = useSelector(alphaEntryTypesSelector)

  const onConvert = e => {
    const { id, original_type_id } = entryTypes.find(({ type }) => type === 'Dropdown')
    const dropdownType = {
      ...defaultValue,
      type: 'Dropdown',
      original_type_id,
      entry_type_id: id,
    }
    dispatch(upgradeTableToPrefilled({
      ...keyField,
      ...dropdownType,
    }))
    onClose(e)
  }

  return (
    <CancelConfirmDialog
      title="Use a pre-filled table?"
      description={`Pre-filled tables only work when the table's key field is a Dropdown. If you continue, we'll change your key field to a Dropdown and turn on the pre-filled table setting for you.`}
      confirmText="Yes, update and use pre-filled table"
      cancelText="Cancel"
      onConfirm={onConvert}
      onCancel={onClose}
    />
  )
}
